import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Store } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { Common, Kind } from 'src/app/common';

@Component({
  selector: 'app-job-save',
  templateUrl: './job-save.component.html',
  styleUrls: ['./job-save.component.scss']
})
export class JobSaveComponent implements OnInit {
  Common = Common;


  constructor(private route: ActivatedRoute, private router: Router, public jobService: JobService,
    private spinner: SpinnerService, private store: Store) { }

  get payAmount() {
    return Math.round((this.amount - (this.job.Budget || this.jobService.BasePrice)) * (100 - this.user.Agent.Percentage) / 100);
  }

  get currentImage() {
    return this.job.Image ? (this.job.Image.startsWith('http') ? this.job.Image : environment.app.filesUrl + this.job.Image) : null;
  }

  get service() { return this.jobService.services.find(_ => _.min <= this.amount && (_.max == null || _.max > this.amount)); }
  get step() { return this.service.step; }
  get view() { return Math.round(this.amount / this.job.CostPerClick); }

  job: any;
  user: any;
  amount: number;
  image: File;
  preview: string | ArrayBuffer;

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.spinner.show();
      this.route.params.subscribe(async params => {

        this.user = this.store.selectSnapshot(state => state.auth.user);
        this.job = params['id']
          ? await this.jobService.getForAgent(params['id'])
          : {
            Educations: [],
            JobTypes: [],
            Kind: Kind.Basic,
            ExpirationTime: new Date(new Date().setDate(new Date().getDate() + 14)),
            Code: -1,
            CostPerClick: 300,
            Budget: 0,
            State: this.user.Agent.State,
            City: this.user.Agent.City,
            District: this.user.Agent.District,
            GeoPoint: this.user.Agent.GeoPoint,
          };
        this.amount = this.job.Budget || this.jobService.BasePrice;

        resolve();
        this.spinner.hide();
      });
    });
  }

  loadImage(image: File) {
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => this.preview = reader.result;
    this.image = image;
  }
  removeImage(element: HTMLInputElement) {
    delete this.preview;
    delete this.image;
    delete this.job.Image;
    element.value = '';
  }

  setKey(array: string[], key: string, event: Event) {
    const set = (<HTMLInputElement>event.target).checked;
    const i = array.indexOf(key);
    if (i >= 0 && !set) { array.splice(i, 1); }
    if (i < 0 && set) { array.push(key); }
  }
  hasKey(array: string[], key: string) {
    if (!array) { return false; }
    return array.indexOf(key) >= 0;
  }

  async save() {
    this.spinner.show();
    await this.jobService.saveForAgent(this.job, this.payAmount, this.image);
    if (this.payAmount == 0) {
      this.router.navigate(['/agent', 'ads']);
    }
    this.spinner.hide();
  }

  setMinAmount(minAmount: number) {
    if (this.amount < minAmount) {
      this.amount = minAmount;
    }
  }
}
